/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SoftwareEnvironmentSpecListSchema } from './SoftwareEnvironmentSpecListSchema';
import {
    SoftwareEnvironmentSpecListSchemaFromJSON,
    SoftwareEnvironmentSpecListSchemaFromJSONTyped,
    SoftwareEnvironmentSpecListSchemaToJSON,
} from './SoftwareEnvironmentSpecListSchema';

/**
 * 
 * @export
 * @interface PagedSoftwareEnvironmentSpecListSchema
 */
export interface PagedSoftwareEnvironmentSpecListSchema {
    /**
     * 
     * @type {Array<SoftwareEnvironmentSpecListSchema>}
     * @memberof PagedSoftwareEnvironmentSpecListSchema
     */
    items: Array<SoftwareEnvironmentSpecListSchema>;
    /**
     * 
     * @type {number}
     * @memberof PagedSoftwareEnvironmentSpecListSchema
     */
    count: number;
}

/**
 * Check if a given object implements the PagedSoftwareEnvironmentSpecListSchema interface.
 */
export function instanceOfPagedSoftwareEnvironmentSpecListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function PagedSoftwareEnvironmentSpecListSchemaFromJSON(json: any): PagedSoftwareEnvironmentSpecListSchema {
    return PagedSoftwareEnvironmentSpecListSchemaFromJSONTyped(json, false);
}

export function PagedSoftwareEnvironmentSpecListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagedSoftwareEnvironmentSpecListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(SoftwareEnvironmentSpecListSchemaFromJSON)),
        'count': json['count'],
    };
}

export function PagedSoftwareEnvironmentSpecListSchemaToJSON(value?: PagedSoftwareEnvironmentSpecListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(SoftwareEnvironmentSpecListSchemaToJSON)),
        'count': value.count,
    };
}

